export default (app) => {
  let core = {
    setModuleTitle(value) {
      if (value) {
        app.store.commit("core/setCustomTitle", value)
      }
    }
  }
  return { core };
} 